<template>
    <div class="channelItem oddsItem" :class="{'oddsItemDark':isDark}">
        <div class="title">
            <div class="left">
                <p>
                    <img src="@/assets/img/datamodel/match/iconSmallOdds.png" alt="图表">
                    {{data.info.name}}
                </p>
                <em v-if="data.is_buy == 1 && data.has_data == 1" @click="goto(data.analy.url)">查看详情分析 ></em>
                <span v-else>{{  data.info.tag }}</span>
            </div>
            <div class="right">{{data.info.buy_count}}人解锁</div>
        </div>
        <div class="con">
            <div v-if="data.is_buy == 0 && data.has_data == 1" class="noVipHaveData" @click="goto(data.info.url)">
                <img v-if="isDark" src="@/assets/img/datamodel/match/noDataOddsDark.png" alt=""/>
                <img v-else src="@/assets/img/datamodel/match/noDataOdds.png" alt=""/>
            </div>
            <div v-if="data.has_data == 0" class="noData">
                <div class="txt">
                    {{ data.info.desc }}
                </div>
                <div class="btm">
                    <div class="top">
                       <p class="res"> <span>历史命中</span> {{ dealDate(data.schedule.match_time) }} {{ data.schedule.sclass_name }}</p>
                       <p class="btn" @click="goto(data.info.url)">查看更多比赛预测</p>
                    </div>
                    <div class="info">
                        <div class="bettel">
                            <div class="team">
                                <p>{{ data.schedule.home_team }}</p>
                                <span>{{ data.schedule.home_score }}</span>
                            </div>
                            <div class="team">
                                <p>{{ data.schedule.guest_team }}</p>
                                <span>{{ data.schedule.guest_score }}</span>
                            </div>
                        </div>
                        <div class="predict">
                            <img src="../../../assets/img/datamodel/match/hit.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="data.is_buy == 1 && data.has_data == 1" class="haveData">
                <div class="con">
                    <div class="chartsBox">
                        <div class="chartItem">
                            <div class="top">
                                <p>全部相似比赛</p>
                                <span>（共{{data.analy.count}}场）</span>
                            </div>
                            <div class="chart">
                                <div class="item">
                                    <div :style="{'height':data.analy.all.home}" class="process win">
                                        <span>{{data.analy.all.home}}</span>
                                    </div>
                                </div>
                                <div class="item">
                                    <div :style="{'height':data.analy.all.stand }" class="process draw">
                                        <span>{{data.analy.all.stand}}</span>
                                    </div>
                                </div>
                                <div class="item">
                                    <div :style="{'height':data.analy.all.guest}" class="process loss">
                                        <span>{{data.analy.all.guest}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="chartItem">
                            <div class="top">
                                <p>TOP10统计</p>
                            </div>
                            <div class="chart">
                                <div class="item">
                                    <div :style="{'height':data.analy.top.home}" class="process win">
                                        <span>{{data.analy.top.home}}</span>
                                    </div>
                                </div>
                                <div class="item">
                                    <div :style="{'height':data.analy.top.stand}" class="process draw">
                                        <span>{{data.analy.top.stand}}</span>
                                    </div>
                                </div>
                                <div class="item">
                                    <div :style="{'height':data.analy.top.guest}" class="process loss">
                                        <span>{{data.analy.top.guest}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="legend">
                        <div class="item">
                            <div class="icon win"></div>
                            主胜
                        </div>
                        <div class="item">
                            <div class="icon draw"></div>
                            平局
                        </div>
                        <div class="item">
                            <div class="icon loss"></div>
                            客胜
                        </div>
                    </div>
                </div>
                <div class="explain">
                    {{ data.analy.msg }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { isLogin, doLogin, isJHAppios, isJHApp } from "../../../utils/base"
export default {
    name: 'oddsItem',
    props: ['data', 'isDark'],
    methods: {
        gobuy () {
            if (!isLogin) {
                doLogin();
                return
            }
            let url = ""
            if (isJHAppios() || !isJHApp()) {
                url = process.env.VUE_APP_H5_DOMAIN + '/page/new_pay?ordertype=pay_data&type=' + this.data.info.data_type;
            } else {
                url = process.env.VUE_APP_DOMAIN + '/user/payment?type=' + this.data.info.data_type;
            }
            this.$emit('gobuy', url)
        },
        goto (url) {
            this.$emit('goModel', url)
        },
        dealDate (str) {
            return str.substring(5, 10).replace('-', '/')
        }
    }
}
</script>

<style lang="less" scoped>
.oddsItem{
    .noData{
        .predict{
            width: 50px;
            height: 50px;
            img{
                width: 100%;
            }
        }
    }
    .con{
        .chartsBox{
            display: flex;
            justify-content: space-between;
            .chartItem{
                width: 120px;
                .top{
                    height: 32px;
                    text-align: center;
                    p{
                        font-size: 12px;
                        line-height: 17px;
                        color: #333333;
                    }
                    span{
                        font-size: 10px;
                        color: #999999;
                        line-height: 14px;
                    }
                }
                .chart{
                    margin-top: 12px;
                    display: flex;
                    justify-content: space-between;
                    .item{
                        width: 30px;
                        height: 75px;
                        background-color: #EEEEEE;
                        border-top-left-radius: 2px;
                        border-top-right-radius: 2px;
                        position: relative;
                        .process{
                            position: absolute;
                            width: 100%;
                            left: 0;
                            bottom: 0;
                            border-top-left-radius: 2px;
                            border-top-right-radius: 2px;
                            span{
                                display: block;
                                width: 100%;
                                font-size: 10px;
                                text-align: center;
                                line-height: 14px;
                                position: absolute;
                                top: -15px;
                                font-weight: bold;
                            }
                        }
                        .win{
                            background-color: #FF5048;
                            span{
                                color: #FF5048;
                            }
                        }
                        .draw{
                            background-color: #169AFF;
                            span{
                                color: #169AFF;
                            }
                        }
                        .loss{
                            background-color: #43A000;
                            span{
                                color: #43A000;
                            }
                        }
                    }
                }
            }
        }
        .legend{
            width: 170px;
            margin: 10px auto;
            display: flex;
            justify-content: space-between;
            .item{
                font-size: 10px;
                color: #666666;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .icon{
                    width: 10px;
                    height: 10px;
                    border-radius: 1px;
                    margin-right: 5px;
                }
                .win{
                    background-color: #FF5048;
                }
                .draw{
                    background-color: #169AFF;
                }
                .loss{
                    background-color: #43A000;
                }
            }
        }
    }
    .explain{
        font-size: 12px;
        line-height: 18px;
        color: #333333;
    }
}
.oddsItemDark{
    .haveData{
        background-color: #232323 !important;
    }
    .con{
        // background-color: #232323;
        .chartsBox{
            .chartItem{
                .top{
                    p{
                        color: #d3d3d3 !important;
                    }
                    span{
                        color: #595959 !important;
                    }
                }
                .chart{
                    .item{
                        background-color: #2f2f2f !important;
                    }
                }
            }
        }
        .legend{
            .item{
                color: #a6a6a6
            }
            .explain{
                color: #d3d3d3;
            }
        }
    }
    .explain{
        color: #d3d3d3 !important;
    }
}
</style>
